// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1bGU9","title":"Header_title__3T7lU","side":"Header_side__3mDo3"};